export default "__VITE_ASSET__CaloIn89__"